import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { DateTimeService } from '../../shared/datetime/datetime.service';
import { BizDataGridDirective } from '../../shared/grid/biz-grid.directive';
import { MessageCancellationService } from '../services/messagecancellation.service';
import { Router } from '@angular/router';
import { GenericModalService } from 'src/app/shared/generic-modal/generic-modal.service';
import { TrackingService } from '../services/tracking.service';

import { DxDataGridModule } from 'devextreme-angular';
import { DxiColumnModule, DxiButtonModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { TrackingStatusLabelComponent } from '../tracking-status-label.component';

@Component({
    selector: 'app-tracking-cancelled-messages-details',
    templateUrl: './tracking-cancelled-messages-details.component.html',
    styleUrls: ['./tracking-cancelled-messages-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxDataGridModule, BizDataGridDirective, DxiColumnModule, DxiButtonModule, DxTemplateModule, TrackingStatusLabelComponent]
})

export class CancelMessageStatusDeatilsComponent implements AfterViewInit  {

    constructor(private messageCancellationService: MessageCancellationService, public dateTimeService: DateTimeService, private modalService: GenericModalService, private router: Router) { }

    dataSourceItems: any[];// = [];

    @ViewChild(BizDataGridDirective, { static: true }) private datagrid: BizDataGridDirective;

    @Input() correlationId: any;

    ngAfterViewInit() {
        this.refresh();
    }

    refresh()
    {
        this.messageCancellationService.getCancelledDocuments(this.correlationId).then((result) => {
            if (result) {
                this.dataSourceItems = result;
            }
            else {
            }
        }).catch();
    }

    showDocument=(e)=>
    {
        const row = e.row.data;

        const searchIdObject = {};
        searchIdObject['documentIds'] = row.DocumentId;

        this.router.navigate(['tracking/result/details', searchIdObject]);
    };

    showDocuments() {
        this.messageCancellationService.getCancellationDetails(this.correlationId).then((result) => {
            if (result) {
                const documentIds = result.DocumentIds;
                const interchangeInIds = result.InterchangeInIds;
                const interchangeOutIds = result.InterchangeOutIds;

                if (documentIds.length > 0 || interchangeInIds.length > 0) {

                    if ((documentIds.length + interchangeInIds.length) > TrackingService.maxNumberOfDocumentsToShow) {
                        const maxDocuments = TrackingService.maxNumberOfDocumentsToShow;
                        this.modalService.messageDirect('Maximum number of documents', `Maximum number of documents to show is ${maxDocuments}`);
                    }
                    else {
                        const searchIdObject = {};
                        if (documentIds.length > 0) {
                            searchIdObject['documentIds'] = documentIds.join(',');
                        }
                        if (interchangeInIds.length > 0) {
                            searchIdObject['interchangeInIds'] = interchangeInIds.join(',');
                        }
                        this.router.navigate(['tracking/result/details', searchIdObject]);
                    }
                }
            }
        });
    }
}
